import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ArrowRightIcon, ZapIcon } from 'lucide-react';
export function FinalCTASection() {
  return <section className="bg-zinc-900 py-16 sm:py-24" data-id="element-84">
      <div className="max-w-4xl mx-auto px-4" data-id="element-85">
        {/* Urgency */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-amber-500/10 border border-amber-500/30 rounded-2xl p-6 sm:p-8 mb-10" data-id="element-86">
          <div className="flex items-center gap-3 mb-4" data-id="element-87">
            <ClockIcon className="w-6 h-6 text-amber-400" data-id="element-88" />
            <span className="text-amber-400 font-bold" data-id="element-89">IMPORTANTE</span>
          </div>
          <p className="text-zinc-300 text-lg leading-relaxed" data-id="element-90">
            Los APKs de Magis TV se actualizan constantemente. Los links
            cambian. Las versiones quedan obsoletas.{' '}
            <span className="text-white font-semibold" data-id="element-91">
              Esta guía está actualizada a 2025 — pero no podemos garantizar que
              siga siendo válida si esperas demasiado.
            </span>
          </p>
          <p className="text-amber-400 font-medium mt-4" data-id="element-92">
            La persona que lo instala hoy disfruta del contenido esta noche. La
            que espera, vuelve a buscar en YouTube la próxima semana.
          </p>
        </motion.div>

        {/* Final CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-emerald-500/20 via-emerald-500/10 to-cyan-500/20 border border-emerald-500/30 rounded-3xl p-8 sm:p-12 text-center" data-id="element-93">
          <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-94">
            <ZapIcon className="w-8 h-8 text-emerald-400" data-id="element-95" />
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4" data-id="element-96">
            ¿Listo para tener <span className="text-emerald-400" data-id="element-97">Magis TV</span>{' '}
            funcionando hoy?
          </h2>

          <p className="text-zinc-400 text-lg mb-8 max-w-xl mx-auto" data-id="element-98">
            ¿Cuántas noches más vas a perderte el partido? ¿Cuántas veces más
            vas a cerrar un tutorial frustrado?
          </p>

          <a href="#" className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-emerald-500 to-emerald-400 hover:from-emerald-400 hover:to-emerald-300 text-black font-black text-lg sm:text-xl px-8 sm:px-12 py-5 sm:py-6 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-emerald-500/30 mb-6" data-id="element-99">
            <span data-id="element-100">SÍ, QUIERO LA GUÍA AHORA</span>
            <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-101" />
          </a>

          <p className="text-zinc-500 text-sm" data-id="element-102">
            Acceso inmediato • Compatible con Android y Smart TV • Actualizada
            2025
          </p>

          {/* One-liner */}
          <div className="mt-8 pt-8 border-t border-zinc-700" data-id="element-103">
            <p className="text-xl text-white font-medium" data-id="element-104">
              Esta es la <span className="text-emerald-400" data-id="element-105">última guía</span>{' '}
              que vas a necesitar.
            </p>
          </div>
        </motion.div>

        {/* Social proof one-liner */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center text-zinc-500 text-lg mt-10 italic" data-id="element-106">
          "Cada mes que sigues pagando streaming, alguien más ya instaló Magis
          TV gratis."
        </motion.p>
      </div>
    </section>;
}